import { FormInput, FormSelect } from "@/components";
import useFilter from "./useFilter";
import { FormProvider } from "react-hook-form";
import {
  Button,
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui";
import { CATEGORY, NAME, PRIORITY, TERM } from "../consts";
import { X } from "lucide-react";
import { FC } from "react";
import { FilterProps } from "./types";
import { useTaskCategoryQuery, useTaskTermQuery } from "@/services/masterData";
import { PRIORITY_TYPES } from "../AddEdit/const";

const Filter: FC<FilterProps> = ({
  onCancel,
  filterData,
  setFilterData,
  onApply,
}) => {
  const { form, onSubmit, requiredFields, isMobile, onClear } = useFilter({
    filterData,
    setFilterData,
    onCancel,
    onApply,
  });
  const { errors } = form.formState;

  const priorityOptions = Object.values(PRIORITY_TYPES).map((p) => ({
        label: p.charAt(0).toUpperCase() + p.slice(1).toLowerCase(), 
        value: p, 
  }));

  const { data: categoriesRes, isLoading: isLoadingCategories } = useTaskCategoryQuery({});
  const { data: termsRes, isLoading: isLoadingTerms } = useTaskTermQuery({});
  
    const categories =
      categoriesRes?.data?.[0]?.records?.map((item: any) => ({
        label: item.name,
        value: item._id,
      })) || [];
  
    const terms =
      termsRes?.data?.[0]?.records?.map((item: any) => ({
        label: item.taskTerm,
        value: item._id,
      })) || [];

  return (
    <Drawer open={true} direction={isMobile ? "bottom" : "right"}>
      <DrawerContent className="px-6">
        <DrawerHeader className="px-0">
          <div className="flex items-center justify-between">
            <DrawerTitle className="text-[20px]">Filter</DrawerTitle>
            <X
              onClick={onCancel}
              className="cursor-pointer stroke-g-300 hover:stroke-g-400"
            />
          </div>
        </DrawerHeader>

        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="relative">
            <div className="bg-white rounded-lg py-[25px] max-h-[70vh] lg:max-h-[95vh] overflow-y-auto pb-[130px] px-1">
              <div className="grid grid-cols-1 gap-[25px]">
                <FormInput
                  name={NAME}
                  control={form.control}
                  label="Task Name"
                  placeholder="Please enter"
                  error={errors[NAME]?.message}
                  isRequired={requiredFields.includes(NAME)}
                />
                <FormSelect
                  name={CATEGORY}
                  control={form.control}
                  label="Task Category"
                  placeholder="Please select"
                  error={errors[CATEGORY]?.message}
                  isRequired={requiredFields.includes(CATEGORY)}
                  options={categories}
                />
                <FormSelect
                  name={PRIORITY}
                  control={form.control}
                  label="Priority"
                  placeholder="Please select"
                  error={errors[PRIORITY]?.message}
                  isRequired={requiredFields.includes(PRIORITY)}
                  options={priorityOptions}
                />
                <FormSelect
                  name={TERM}
                  control={form.control}
                  label="Task Term"
                  placeholder="Please select"
                  error={errors[TERM]?.message}
                  isRequired={requiredFields.includes(TERM)}
                  options={terms}
                />
              </div>
            </div>
            <div className="flex flex-col gap-3 absolute bottom-3 w-full bg-white pb-[25px] z-[3]">
              <div className="flex justify-end">
                <Button
                  variant="ghost"
                  type="button"
                  className="text-red-600"
                  onClick={onClear}
                >
                  Clear All
                </Button>
              </div>
              <Button type="submit">Apply Filter</Button>
            </div>
          </form>
        </FormProvider>
      </DrawerContent>
    </Drawer>
  );
};

export default Filter;
